/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes, { any } from 'prop-types';
import { useDispatch } from 'react-redux';

import AvatarV2 from '../../../../../components/cards/PlayerCard/ListViewComponents/AvatarV2';
import Img from '../../../../../components/Img';
import styles from './eligiblePlayersTabContent.scss';
import * as eventProfileActions from '../../../../../actions/event-profile-actions';
import ColumnHeader from '../../../../../components/ColumnHeader';
import DebouncedFilterInput from '../../../../../components/FormElementsStandalone/DebouncedFilterInput';
import { debounce } from '../../../../../utils/debounceUtil';
import Pagination from '../../../../../components/Pagination';
import Rating from '../../../../../components/cards/PlayerCard/SharedComponents/Rating';

const EligiblePlayersTabContent = (props) => {
  const { eventId, eligiblePlayers, isPickleballEvent, utrTypeId, sportTypeId, isCurrentMemberAdmin } = props;
  const [eligiblePlayersList, setEligiblePlayersList] = useState(eligiblePlayers?.data?.players ?? []);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState();
  const totalPages = eligiblePlayers?.data?.total ? Math.ceil(eligiblePlayers.data?.total / 100) : 1;

  const dispatch = useDispatch();
  useEffect(() => {
      getUpdatedEligibleList();
  }, []);
  useEffect(() => {
    setEligiblePlayersList(eligiblePlayers?.data?.players);
  }, [eligiblePlayers?.data?.players]);
  useEffect(() => {
    if (currentPage || searchTerm) {
      getUpdatedEligibleList(currentPage, searchTerm);
    }
  }, [currentPage, searchTerm]);

  const getUpdatedEligibleList = async (page, search) => {
      await dispatch(eventProfileActions.getEligiblePlayers(eventId, page, search));
  };

  const handleDeletePlayer = async (playerId) => {
      const response = await dispatch(eventProfileActions.deleteEligiblePlayer(eventId, playerId));
      if (response) {
        const updatedList = eligiblePlayersList.filter((player) => player.playerId !== playerId);
        setEligiblePlayersList(updatedList);
        if (updatedList.length < 1) {
            window.location.reload();
        }
      }
    };

    const gridLayout = [
      '8fr',
      '3fr',
      '3fr',
      '3fr',
      '4fr',
    ];

    const handlePageChange = (page) => {
      setCurrentPage(page);
    };

    const handleSearch = (searchT) => {
      setCurrentPage(1);
      setSearchTerm(searchT);
    };

  const debouncedHandleSearch = debounce(handleSearch, 250);

    return (
        <div className="mt24">
            <div className={styles.anchorWrapper}>
                <DebouncedFilterInput
                    className={styles.anchorClass}
                    placeholder="Find player(s)"
                    hideSearchIcon
                    onChange={debouncedHandleSearch}
                />
            </div>
            <div className="d-flex text-small fw600 division-tab-header-v4">
                <div className="flex-grow">
                    <div className="row">
                        <div className={`col-12`}>
                            <div className="d-grid w-100" style={{ gridTemplateColumns: gridLayout.map(fr => `minmax(0, ${fr})`).join(' ') }}>
                                <ColumnHeader
                                    columnName="Player name"
                                />
                                <ColumnHeader
                                    columnName={isPickleballEvent ? 'UTR-P' : 'UTR'}
                                    imgUrl="/img/v3/icons/icon-singles-black.svg"
                                />
                                <ColumnHeader
                                    columnName={isPickleballEvent ? 'UTR-P' : 'UTR'}
                                    imgUrl="/img/v3/icons/icon-doubles-black.svg"
                                />
                                <ColumnHeader
                                    columnName={`Date added`}
                                />
                                <ColumnHeader
                                    columnName={``}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`p-rel ${eligiblePlayers?.loading && 'opacity05'}`}>
                {eligiblePlayersList?.map((player) => {
                        const date = player?.dateAdded ? new Date(player.dateAdded).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : '';
                        return (
                            <div key={`player-${player.playerId}-${player.divisionCategoryName}`} data-testid={`event-profile.eligible-players.player-${player.playerId}`}>
                                <div className={`utr-card division-card-v4 d-flex desktop ${styles.eligiblePlayerCard}`} style={{ background: '#fff' }}>
                                    <div style={{ background: '#fff', width: '100%' }}>
                                        <div className="d-grid w-100" style={{ gridTemplateColumns: gridLayout.map(fr => `minmax(0, ${fr})`).join(' ') }}>
                                            <div className="d-flex aic pr8">
                                                <div className="no-gutters">
                                                    <div className="d-flex aic" onClick={() => { }}>
                                                        <div className={`d-flex aic oh pr8`}>
                                                            <AvatarV2 player={player} />
                                                        </div>
                                                        <div className="d-flex flex-col">
                                                            <a href={`/profiles/${player.playerId}`} data-testid={`event-profile.eligible-players.player-${player.playerId}.profile-link`}>{player.firstName} {player.lastName}</a>
                                                            <div className={`${styles.playerLocation} d-flex`} data-testid={`event-profile.eligible-players.player-${player.playerId}.location`}><span>{player.gender}</span>{player.location?.display && (<span>• {player.location?.display}</span>)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex aic pl4">
                                                {isPickleballEvent ? (
                                                    <Rating
                                                        utrType={utrTypeId}
                                                        ratingType={'singles'}
                                                        player={player}
                                                        showDecimals={isCurrentMemberAdmin}
                                                        hideUtrLabel={true}
                                                        sportTypeId={sportTypeId}
                                                        isPickleballRating
                                                    />
                                                ) : (
                                                    <Rating
                                                        utrType={utrTypeId}
                                                        ratingType={'singles'}
                                                        ratingStatus={player.ratingStatusSingles}
                                                        player={player}
                                                        showDecimals={isCurrentMemberAdmin}
                                                        hideUtrLabel={true}
                                                        sportTypeId={sportTypeId}
                                                    />
                                                )}
                                            </div>
                                            <div className="d-flex aic pl4">
                                                {isPickleballEvent ? (
                                                    <Rating
                                                        utrType={utrTypeId}
                                                        ratingType={'doubles'}
                                                        player={player}
                                                        showDecimals={isCurrentMemberAdmin}
                                                        hideUtrLabel={true}
                                                        sportTypeId={sportTypeId}
                                                        isPickleballRating
                                                    />
                                                ) : (
                                                    <Rating
                                                        utrType={utrTypeId}
                                                        ratingType={'doubles'}
                                                        ratingStatus={player.ratingStatusDoubles}
                                                        player={player}
                                                        showDecimals={isCurrentMemberAdmin}
                                                        hideUtrLabel={true}
                                                        sportTypeId={sportTypeId}
                                                    />
                                                )}
                                            </div>
                                            <div className="d-flex aic pr8" data-testid={`event-profile.eligible-players.player-${player.playerId}.date-added`}>{date}</div>
                                            <div className="d-flex aic jce">
                                                <Img src={'/img/v3/icons/icon-trash-red.svg'} className="cursor-pointer pl8" onClick={() => handleDeletePlayer(player.playerId)} data-testid={`event-profile.eligible-players.player-${player.playerId}.delete-btn`} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
            {eligiblePlayers?.loading && (
                <div className="row divisions-big" data-testid="event-profile.eligible-players.loading">
                    <div className="col">
                        Loading player list...
                    </div>
                </div>
            )}
            {!eligiblePlayers?.loading && !eligiblePlayersList?.length && (
                <div className="row divisions-big" data-testid="event-profile.eligible-players.empty">
                    <div className="col">
                        No players are matching your filter criteria.
                    </div>
                </div>
            )}
            {totalPages > 1 && (
                <Pagination
                    lastPage={totalPages}
                    currentPage={currentPage ?? 1}
                    onClick={handlePageChange}
                />
            )}
        </div>
    );
};

EligiblePlayersTabContent.propTypes = {
    eligiblePlayers: PropTypes.objectOf(any).isRequired,
    isPickleballEvent: PropTypes.bool,
    eventId: PropTypes.number,
    utrTypeId: PropTypes.number,
    sportTypeId: PropTypes.number,
    isCurrentMemberAdmin: PropTypes.bool,
};
EligiblePlayersTabContent.defaultProps = {
    isPickleballEvent: true,
    eventId: 0,
    utrTypeId: 2,
    sportTypeId: 2,
    isCurrentMemberAdmin: false,
};

export default withRouter(EligiblePlayersTabContent);
